import React from "react";
import Routes from "./Routes/index";
import "./assets/scss/theme.scss";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import fakeBackend from "./helpers/AuthType/fakeBackend";
import { MachineProvider } from "./context/MachineContext";
import { PageGridProvider } from "./context/PageGridContext";

fakeBackend();

function App() {
  return (
    <React.Fragment>
      <MachineProvider>
        <PageGridProvider>
          <Routes />
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
          />
        </PageGridProvider>
      </MachineProvider>
    </React.Fragment>
  );
}

export default App;
